export const DASHBOARD_SSE_PATH = '/api/stream/__dashboard__';
